<div class="kkm-input-popover"
     [ngClass]="class"
     [class.kkm-input-popover_bottom]="position === 'bottom'"
     [class.kkm-input-popover_left]="position === 'left'"
     [class.kkm-input-popover_top]="position === 'top'">
  <div class="kkm-input-popover__inner">
    <span class="small_text" [innerHTML]="text"></span>
  </div>
</div>
